import PropTypes from 'prop-types';

import Container, { ContainerProps as MuiContainerProps } from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Helmet from '../../components/Helmet';
import { Box, Typography } from '@mui/material';
import { DashboardLayout } from '../../layouts';
import { windowExists } from '@classity-edtech/ui-base';
import { webPaths } from '../../routes/paths';
import { useGetProfileQuery } from '../../services/profile';
import { useGetMyProfileQuery } from '../../services/users';
import PendingState from '../../components/PendingState';

export interface AdminDashboardProps extends MuiContainerProps {}

export const AdminDashboard = ({ className }: AdminDashboardProps) => {
  const navigate = useNavigate();

  const { data: user } = useGetMyProfileQuery();

  const { data: profile } = useGetProfileQuery(
    {
      userId: user?.id,
    },
    { skip: !user?.id },
  );

  const handleLogout = () => {
    (windowExists as any)?.localStorage.removeItem('token');
    navigate(`${webPaths.root}`);
  };

  return (
    <>
      <Helmet />

      <DashboardLayout
        profileDropdown={{
          memberId: profile?.ids?.find(u => u?.name === 'uid')?.value,
          logoutAction: handleLogout,
        }}
      >
        <Box sx={{ display: 'flex', gap: 3, items: 'center' }}>
          <Typography variant='subtitle3'>
            Welcome back,&nbsp;{profile?.firstname || 'Admin'}
          </Typography>
        </Box>
        <PendingState />
      </DashboardLayout>
    </>
  );
};

AdminDashboard.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

AdminDashboard.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(AdminDashboard)(
  ({ theme }) => `
`,
);
